import { Component } from '@angular/core';

@Component({
    selector: 'bb-phone-number-pipe-page-ui',
    templateUrl: './bb-phone-number-page-ui.component.html',
    standalone: false,
})
export class PhoneNumberPageComponent {}
